import { render, staticRenderFns } from "./FriendlyLink.vue?vue&type=template&id=692f0dc0"
import script from "./FriendlyLink.vue?vue&type=script&lang=js"
export * from "./FriendlyLink.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports